import { algoliaEnv } from './colombia/algolia.env';
import { apiKey } from './api-keys';
import { algoliaConfig } from './algolia-config';
import { algoliaVzlaEnv } from './venezuela/algolia.env';
import { ApiExternalEnum } from '../base-urls/api-external.enum';
import { BackendGatewayColEnum } from '../base-urls/backend-gateway-col.enum';
import { BackendGatewayVenEnum } from '../base-urls/backend-gateway-ven.enum';
import { yunoKey } from './yuno-api-key';

export const environment = {
  ssr: true,
  hmr: false,
  production: true,
  callCenter: false,
  multiCountry: true,
  algoliaColombia: algoliaEnv.envs.prod,
  algoliaVenezuela: algoliaVzlaEnv.envs.prod,
  algoliaEnv: algoliaEnv,
  algoliaConfig,
  deploymentVersion: { developmentMode: false },
  apiKey,
  yunoKey,
  date: new Date(),
  firebaseConfigOptic :{
    apiKey: "AIzaSyBqN75USy4QEuh4WenLwbA3gJBtkRPyMAI",
    authDomain: "optica-52e75.firebaseapp.com",
    projectId: "optica-52e75",
    storageBucket: "optica-52e75.appspot.com",
    messagingSenderId: "813783981162",
    appId: "1:813783981162:web:c2f9e5701ac8cbd7817e13"
  },
  backendColombia: {
    multiCountry: BackendGatewayColEnum.BACKEND_MULTICOUNTRY,
    be2: `${BackendGatewayColEnum.MULTICOUNTRY}_ah/api/`,
    sas: BackendGatewayColEnum.MULTICOUNTRY,
    gateway: BackendGatewayColEnum.MULTICOUNTRY,
    dataFoundation: BackendGatewayColEnum.MULTICOUNTRY,
    cms: BackendGatewayColEnum.MULTICOUNTRY,
    utilities: BackendGatewayColEnum.MULTICOUNTRY,
    cloudFunction: BackendGatewayColEnum.CLOUD_FUNCTION,
    bzv: ApiExternalEnum.BZV,
    qa1: BackendGatewayColEnum.QA_ENV_1,
    crm: BackendGatewayColEnum.CRM,
    mp: BackendGatewayColEnum.MP,
    apiMp: BackendGatewayColEnum.API_MP,
    alg: BackendGatewayColEnum.ALGOLIA,
    countriesSelect: BackendGatewayVenEnum.COUNTRIES_SELECT,
    talonOne :`${BackendGatewayColEnum.TALONONE}_ah/api/`,
    monitor : BackendGatewayColEnum.MONITOR,
    yuno: `${BackendGatewayColEnum.YUNO}_ah/api/`,
    yunoCreate: BackendGatewayColEnum.YUNO,
    apiOperational: BackendGatewayColEnum.API_OPERATIONAL,
    courier: BackendGatewayColEnum.COURIER,
    marketplace_order: BackendGatewayColEnum.MARKETPLACE_ORDER,
    be2Home: `${BackendGatewayColEnum.MULTICOUNTRY}_ah/v2/api/`,
    recaptcha: BackendGatewayColEnum.RECAPTCHA,
    gatewayData: BackendGatewayColEnum.GATEWAYDATA
  },
  backendVenezuela: {
    be2: `${BackendGatewayVenEnum.MULTICOUNTRY}_ah/api/`,
    sas: BackendGatewayVenEnum.MULTICOUNTRY,
    gateway: BackendGatewayVenEnum.MULTICOUNTRY,
    dataFoundation: BackendGatewayVenEnum.MULTICOUNTRY,
    cms: BackendGatewayVenEnum.MULTICOUNTRY,
    cloudFunction: BackendGatewayVenEnum.CLOUD_FUNCTION,
    bzv: ApiExternalEnum.BZV,
    alg: BackendGatewayVenEnum.ALGOLIA,
  },
};


